import React, { useRef, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import { fetchDataActive, fetchData, postData, updateData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import { Tooltip } from '@mui/material';
import {
    Search as SearchIcon,
    Add as AddIcon,
    Edit as EditIcon,
    Delete as DeleteIcon
} from '@mui/icons-material';
import {
    TableContainer, Paper, Table, TableHead, TableRow,
    TableCell, TableBody, TablePagination,
    IconButton, Dialog, DialogTitle, DialogContent,
    DialogContentText, DialogActions
} from '@mui/material';

//import '../../styles.css';
function BIndex() {
    const inputRef = useRef(null);
    const [data, setData] = useState([]);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [errorMessage, setErrorMessage] = useState("");
    const { isAuthenticated, clubId, branchId, roleName, userId, username, permissions, logout, token } = useAuth();
    const [successMessage, setSuccessMessage] = useState("");
    const [isButtonVisible, setIsButtonVisible] = useState(true); // initially set to false
    const [deleteManufacture, setDeleteManufacture] = useState(null);
    const [branchid, setBranchid] = useState(branchId);


    useEffect(() => {
        if (roleName === 'SuperAdmin') {
            setBranchid(0);
        } else {
            setBranchid(branchId);
        }
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        // Token is not expired, fetch data
        fetchtableData(branchid);
        //  inputRef.current.focus();
    }, [isAuthenticated, clubId, branchId, token, logout, roleName]);

    const closeConfirmDialog = () => {
        // setDeleteMember(null);
        setConfirmDialogOpen(false);
    };
    useEffect(() => {
        if (searchTerm.trim() == '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter(manu => manu.name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);

    const fetchtableData = async (branchid) => {
        try {
            if (roleName === 'SuperAdmin') {
                branchid = 0;
            } else {
                branchid = branchId;
            }
            const response = await fetchData('BranchApi', `/${clubId}/${branchid}`, token);

            if (response.responseCode === '1111') {
                setData(response.response_data);
                setFilteredData(response.response_data);
            } else {
                console.error('Error: Invalid response code', response.responseCode);
            }
        } catch (error) {
            console.error('Error fetching Club Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                const redirectUrl = encodeURIComponent(window.location.pathname);
                history.replace(`/login?redirect=${redirectUrl}`);
            } else {
                alert('An error occurred. Please try again later.');
            }
        }
    };

    const handleDelete = async () => {
        deleteData('BranchApi', `${deleteManufacture}`)
            .then((response) => {
                fetchtableData();
                setDeleteManufacture(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const [page, setPage] = useState(0); // Current page
    const [rowsPerPage, setRowsPerPage] = useState(5); // Rows per page

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Reset to the first page when changing rows per page
    };



    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>

                <h6 className='productHead flex-grow linkcolor'
                    style={{ color: '#0e728c', fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
                    CLUB</h6>




                <div className="button-container-1">
                    {username.trim() === "efftab_admin" && (
                        <Tooltip title="Create Club">
                            <Button
                                component={Link}
                                to="/BranchCreate"
                                className="linkcolor"
                                style={{ color: 'whitesmoke', fontsize: '11px', backgroundColor: '#27391C', height: '25px', marginLeft: '5px' }}>
                                CREATE
                            </Button>
                        </Tooltip>
                    )}
                </div>


            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table>
                        {/* <TableHead sx={{ backgroundColor: '#0c8bce', fontFamily: 'sans-serif' }}> */}
                        <TableHead sx={{ backgroundColor: '#15abd2', fontFamily: 'sans-serif' }}>
                            <TableRow>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Club</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Code</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Name</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Address</TableCell>
                                <TableCell sx={{ borderBottom: '1px solid #ddd', padding: '4px', color: 'white', fontSize: '12px', fontWeight: 'bold', textTransform: 'uppercase' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody style={{ backgroundColor: '#F5F7F8' }}>
                            {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((chapter, index) => (


                                <TableRow
                                    key={chapter.id}
                                    className={chapter.isActive ? '' : 'inactiveRow'}
                                    sx={{
                                        backgroundColor: index % 2 === 0 ? 'white' : '#ebf9fd', // Alternate row background colors
                                    }}
                                >
                                    <TableCell sx={{ padding: '2px', padding: '2px' }}>{chapter.name}</TableCell>
                                    <TableCell sx={{ padding: '2px', padding: '2px' }}>{chapter.branchCode}</TableCell>
                                    <TableCell sx={{ padding: '2px', padding: '2px' }}>{chapter.name}</TableCell>
                                    <TableCell sx={{ padding: '2px', padding: '2px' }}>{chapter.postalAddress}</TableCell>
                                    <TableCell sx={{ padding: '2px', padding: '2px' }}>

                                        <Link to={`/BranchEdit/${chapter.id}`}>
                                            <Tooltip title="Edit Club">
                                                <IconButton>
                                                    <EditIcon style={{ fontsize: '10px', color: 'blue' }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Link>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={filteredData.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        sx={{
                            '& .MuiTablePagination-toolbar': {
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                flexWrap: 'nowrap', // Ensures everything stays in one line
                                minHeight: '40px', // Keeps a proper height
                            },
                            '& .MuiTablePagination-selectLabel': {
                                marginBottom: 0, // Fixes label misalignment
                            },
                            '& .MuiTablePagination-displayedRows': {
                                marginBottom: 0, // Fixes row count misalignment
                            },
                        }}
                    />
                </TableContainer>

            </div>
        </div>
    );
}

export default BIndex;




